import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PAGE_NAME } from "../../types";
import PageLoadingComponent from "../components/PageLoadingComponent";
import useEnsureUser from "../hooks/useEnsureUser";
import { isAllowedDomain, UnsupportedDomainCard } from "../components/DomainGuard";

/** "/" — decides between Login and Home. */
function Entry() {
  const navigate = useNavigate();
  const { status, retry } = useEnsureUser();

  useEffect(() => {
    if (status === "authenticated") navigate(PAGE_NAME.HOME, { replace: true });
    if (status === "guest") navigate(PAGE_NAME.LOGIN, { replace: true });
  }, [status, navigate]);

  if (!isAllowedDomain()) {
    return <UnsupportedDomainCard />;
  }

  if (status === "error") {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 px-6 text-center">
        <p className="text-gray-600 text-sm">Connection problem. Check your network and try again.</p>
        <button
          onClick={retry}
          className="px-5 py-2.5 rounded-xl bg-indigo-600 text-white font-semibold text-sm"
        >
          Retry
        </button>
      </div>
    );
  }

  return <PageLoadingComponent />;
}

export default Entry;
